module.exports = __webpack_public_path__ + "img/ig-icon.bd0b743.svg";